import React from 'react'
import { Col, Nav, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'

export default function SubMenuDatabase({ section }) {
    const { t } = useTranslation()
    const {client} = useAuth()
    return (
        <Row className='mt-3 mb-5'>
            <Col>
                <Nav defaultActiveKey="/seasons" as="ul" className='selection-submenu'>
                    <Nav.Item as="li">
                        <Nav.Link active={section === "favourites"} as={Link} to={`/${client?.rol === "MultiSchool" ? 'multischool' : "school"}/database/favourites`}>{t("database.submenu.favourites")}</Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li">
                        <Nav.Link active={section === "blocked"} as={Link} to={`/${client?.rol === "MultiSchool" ? 'multischool' : "school"}/database/blocked`}>{t("database.submenu.blocked")}</Nav.Link>
                    </Nav.Item>
                </Nav>
            </Col>
        </Row>
    )
}